import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=52616d86&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"
import style0 from "./Search.vue?vue&type=style&index=0&id=52616d86&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52616d86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52616d86')) {
      api.createRecord('52616d86', component.options)
    } else {
      api.reload('52616d86', component.options)
    }
    module.hot.accept("./Search.vue?vue&type=template&id=52616d86&scoped=true", function () {
      api.rerender('52616d86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/search/Search.vue"
export default component.exports